module.exports = __webpack_public_path__ + "img/5.43c05ce7.jpg";